import { environment } from '@envs/environment';
import { getToken, forceTokenRefresh } from '@config/auth.config';

// Utilisation des paramètres d'environnement APIM
const { apimSubscriptionKey, apimVersion } = environment;

// État global du compte courant
let currentAccount: any = null;

// Fonction pour définir le compte courant
export const setCurrentAccount = (account: any) => {
  currentAccount = account;
};

// Fonction pour obtenir les headers d'API (avec gestion du token)
export const getApiHeaders = async (forceRefresh: boolean = false) => {
  // Vérifier si un compte est défini
  if (!currentAccount) {
    throw new Error('No account has been set. Call setCurrentAccount() first.');
  }

  // Récupérer ou rafraîchir le token
  const userToken = forceRefresh 
    ? await forceTokenRefresh(currentAccount)
    : await getToken(currentAccount);
  
  if (!userToken) {
    throw new Error('Failed to get valid token');
  }
  
  return {
    'Authorization': `Bearer ${userToken}`,
    'Content-Type': 'application/json',
    'Ocp-Apim-Subscription-Key': apimSubscriptionKey,
    'Api-Version': apimVersion,
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, OPTIONS',
    'Ocp-Apim-Trace': 'true',
  };
};

/**
 * Wrapper pour les appels API avec retry automatique sur erreur 401
 */
export const apiCall = async <T>(
  fetchFn: (headers: Record<string, string>) => Promise<Response>
): Promise<T> => {
  let headers = await getApiHeaders();
  let response = await fetchFn(headers);

  // Si 401, rafraîchir le token et réessayer une fois
  if (response.status === 401) {
    console.log('Erreur 401, tentative de refresh du token...');
    headers = await getApiHeaders(true);
    response = await fetchFn(headers);
  }

  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};